import { getCO2Aequivalent } from '../getCO2Aequivalent';
import { getEinheitenUmrechnung } from '../../../bereiche/dateneingabe/functions/getEinheitUmrechung';
import { getEmissionsFaktor, getEmissionsFaktorObject } from '../getEmmissionsFaktor';
import { getGTZHochrechnung } from '../../../bereiche/dateneingabe/dialogs/getGTZHochrechnung';
import { getGTZforJahr, getGTZinRange } from '../../../bereiche/dateneingabe/dialogs/getHochrechnung';
import { getKennzahl, Kennzahl } from '../strukturiert/Kennzahl';
import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { getUmrechungsFaktor } from '../getUmrechnungsFaktor';
import { IDs } from '../../../helpers/IDs';
import { isRenewableWaerme, setKennzahlRenewableWaerme } from './setRenewable';
import { isValid as isValidWaerme } from '../validData';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';
import { getBrennwerteUmrechnungsfaktor } from '../getEmmissionsUmrechnungsfaktor';

export function extractEnergieWaermeNeu(data: any, base: any, standort: any) {
    // console.log('Pre Wärme', standort, JSON.stringify(base));
    const kennziffern_strukturiert = data[IDs.KENNZIFFERN_STRUKTURIERT];

    const standorte = data[IDs.ENT_STANDORT];
    const waerme = data[IDs.ENT_ENERGIEDATEN_WAERME].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);
    const valuesGtz = !standort
        ? data[IDs.ENT_GTZ] || []
        : data[IDs.ENT_GTZ_STANDORT][standort.ort_gtz] || data[IDs.ENT_GTZ] || [];
    // const valuesGtz = data[IDs.ENT_GTZ];
    const gtzHochrechnung = getGTZHochrechnung(valuesGtz);
    const einheiten = data[IDs.ENT_ENERGIEDATEN_WAERME_EINHEITEN];
    const energietraeger = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER];
    // console.log('WÄRME ET', energietraeger);

    // Standorte-Map
    const veranstaltungen_enabled = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    const energietraeger_found: any = {};
    /******************** WÄRME NEU ****************************************************************** */
    waerme.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        if (!standortTid || !standorteMap[standortTid]) {
            // console.log('Ignoring Item: ', item);
            return;
        }
        if (!item.einheit_tid_orig || item.einheit_tid_orig === 0) {
            return;
        }
        if (item.monat && item.monat > 0) {
            return;
        }
        if (!isValidWaerme(item, IDs.ENT_ENERGIEDATEN_WAERME, data)) {
            return;
        }
        base['flags'].hasWaerme = true;
        // console.log('WAERME NEU: ', item);
        const energietraeger_tid = item.energietraeger_tid_orig;
        const abrechnungsart = +item.abrechnungsart;
        const abrechnungsart_name = abrechnungsart ? getStaticOption(IDs.ENT_ENERGIEDATEN_WAERME, 'abrechnungsart', abrechnungsart) : null;
        const einheit_tid = item.einheit_tid_orig;
        const einheit_obj = einheiten.find((eh: any) => eh.tid === einheit_tid);
        const einheit_id = einheit_obj.id;
        // console.log('EINHEIT', item.einheit_tid, einheit_tid, einheit_obj);
        const energietraeger_obj = energietraeger.find((et: any) => et.tid === energietraeger_tid);
        if (!energietraeger_obj) {
            console.log('Kein Energieträger für TID ' + energietraeger_tid);
            return;
        }
        const energietraeger_id = energietraeger_obj.id;
        const energietraeger_name: string = energietraeger_obj.name || energietraeger_id || null;
        //  console.log('ET_ID', energietraeger_id);
        const key_az_von = 'az_von_waerme_' + energietraeger_id;
        const key_az_bis = 'az_bis_waerme_' + energietraeger_id;
        const key_kosten = 'kosten_waerme_' + energietraeger_id;
        const key_verbrauch = 'verbrauch_waerme_' + energietraeger_id + '_' + einheit_id;
        const key_verbrauch_kwh = 'verbrauch_waerme_' + energietraeger_id + '_kwh';
        const key_verbrauch_kwh_base = 'verbrauch_waerme_' + energietraeger_id + '_kwh_base';
        const key_verbrauch_prozess_kwh = 'verbrauch_waerme_prozess_' + energietraeger_id + '_kwh';
        const key_weitergeleitete_waermemenge_kwh = 'weitergeleitete_waermemenge_' + energietraeger_id + '_kwh';
        const key_co2 = 'faktor_co2_' + energietraeger_id;
        const key_co2_quelle = 'faktor_co2_quelle_' + energietraeger_id;
        const key_co2_wert = 'faktor_co2_wert_' + energietraeger_id;
        const key_emission_co2 = 'co2_waerme_' + energietraeger_id;
        const key_co2_fuss_menge = energietraeger_id === 'strom' ? 'co2_fussabdruck_strom_waerme_menge' :
            'co2_fussabdruck_' + energietraeger_id + '_menge';
        const key_co2_fuss_value = energietraeger_id === 'strom' ? 'co2_fussabdruck_strom_waerme_value' :
            'co2_fussabdruck_' + energietraeger_id + '_value';
        energietraeger_found[energietraeger_id] = true;
        const jahr = item.jahr;
        const prozess_waerme = item.prozess_waerme;
        const prozess_fakt = (prozess_waerme && +prozess_waerme > 0) ? (+prozess_waerme / 100) : 0;
        if (!base[jahr]) {
            base[jahr] = {};
        }
        const key_messsystem = `waerme_${energietraeger_id}_messsystem`;
        const key_kalibrierung = `waerme_${energietraeger_id}_kalibrierung`;
        const key_datenqualitaet = `${energietraeger_id}_${einheit_id}_datenqualitaet`;

        const messsystem = item.messsystem;
        const kalibrierung = item.kalibrierung;
        if (messsystem) {
            if (base[jahr][key_messsystem]) {
                base[jahr][key_messsystem] += ', ' + messsystem;
            } else {
                base[jahr][key_messsystem] = messsystem;
            }
        }
        if (kalibrierung) {
            if (base[jahr][key_kalibrierung]) {
                base[jahr][key_kalibrierung] += ', ' + kalibrierung;
            } else {
                base[jahr][key_kalibrierung] = kalibrierung;
            }
        }
        if (!base[jahr][key_datenqualitaet]) {
            base[jahr][key_datenqualitaet] = [];
        }

        if (!base[jahr][key_az_von] || base[jahr][key_az_von] > item.abrechnungszeitraum_von) {
            base[jahr][key_az_von] = item.abrechnungszeitraum_von;
        }
        if (!base[jahr][key_az_bis] || base[jahr][key_az_bis] < item.abrechnungszeitraum_bis) {
            base[jahr][key_az_bis] = item.abrechnungszeitraum_bis;
        }
        // ********************** FAKTOR GTZ ****************
        let factor_hochrechnung = 1;
        let gtz_az: number;
        let gtz_hochrechnung: number;
        let tage_az: number;
        let tage_hochrechnung: number;
        const factor_hochrechnung_quelle: string = `DWD (${jahr}): Gradtagzahlen`;
        const az_von = item.abrechnungszeitraum_von;
        let az_bis = item.abrechnungszeitraum_bis;
        // Tageszeit entfernen
        // const date_von = new Date(+az_von * 1000);
        // const date_von2 = new Date(date_von.getFullYear(), date_von.getMonth(), date_von.getDate());
        const date_bis = new Date(+az_bis * 1000);
        const date_bis2 = new Date(date_bis.getFullYear(), date_bis.getMonth(), date_bis.getDate());
        az_bis = date_bis2.getTime() / 1000;

        const gtz = getGTZinRange(az_von, az_bis, gtzHochrechnung);
        // 1 - Reguläre Abrechnung, 2 - Teilabrechnung, 3 - Erste Abrechnung, 4 - Letzte abrechnung
        // Fall 2 müssen wir nichts machen, da bleibt es beim Faktor 1, da wir nicht hochrechnen.
        if (!abrechnungsart || abrechnungsart === 1) {
            const gtz_jahr = getGTZforJahr(jahr, gtzHochrechnung);
            if (gtz_jahr.days !== gtz.days) { // Wenn ein ganzes Jahr vorliegt (egal ob verschoben) ---> NOP
                factor_hochrechnung = gtz_jahr.sumGTZ / gtz.sumGTZ;
                gtz_az = Math.round(gtz.sumGTZ * 10) / 10;
                gtz_hochrechnung = Math.round(gtz_jahr.sumGTZ * 1e2) / 1e2;
                tage_az = gtz.days;
                tage_hochrechnung = gtz_jahr.days;
            }
        } else if (abrechnungsart === 3) {
            // Wir rechnen von AZ-Von bis zum Jahresende
            const az_ende = new Date(jahr + 1, 0, 1).getTime() / 1000;
            const gtz_teil = getGTZinRange(az_von, az_ende, gtzHochrechnung);
            factor_hochrechnung = gtz_teil.sumGTZ / gtz.sumGTZ;
            gtz_az = Math.round(gtz.sumGTZ * 10) / 10;
            gtz_hochrechnung = Math.round(gtz_teil.sumGTZ * 1e2) / 1e2;
            tage_az = gtz.days;
            tage_hochrechnung = gtz_teil.days;
        } else if (abrechnungsart === 4) {
            // Wir rechnen vom Jahresbegin bis AZ-Bis
            const az_begin = new Date(jahr, 0, 1).getTime() / 1000;
            const gtz_teil = getGTZinRange(az_begin, az_bis, gtzHochrechnung);
            factor_hochrechnung = gtz_teil.sumGTZ / gtz.sumGTZ;
            gtz_az = Math.round(gtz.sumGTZ * 10) / 10;
            gtz_hochrechnung = Math.round(gtz_teil.sumGTZ * 1e2) / 1e2;
            tage_az = gtz.days;
            tage_hochrechnung = gtz_teil.days;
        }
        factor_hochrechnung = Math.round(factor_hochrechnung * 100) / 100;

        // ********************** FAKTOR GTZ ENDE ****************

        const co2_emissionen_t = item.co2_emissionen || item.co2_emissionen === 0 ? item.co2_emissionen / 1000000 : null;
        base[jahr][key_co2] = (!base[jahr][key_co2] || base[jahr][key_co2] < co2_emissionen_t) ?
            co2_emissionen_t : base[jahr][key_co2];
        const umrechnung = getEinheitenUmrechnung(einheit_id, energietraeger_id);
        if (standort) {
            base[jahr][key_kosten] = (base[jahr][key_kosten] || 0) + item.kosten * factor_hochrechnung;
            base[jahr][key_co2] = (!base[jahr][key_co2] || base[jahr][key_co2] < co2_emissionen_t) ?
                co2_emissionen_t : base[jahr][key_co2];

            const kosten: number = typeof item.kosten === 'number' ? item.kosten * factor_hochrechnung : null;
            const zaehler = item.zaehler_tid_orig ? item.zaehler_tid : null;
            let verbrauch_kwh;
            let verbrauch_hoch;
            if (einheit_id !== 'kwh') {
                base[jahr][key_verbrauch] = (base[jahr][key_verbrauch] || 0) + item.verbrauch * factor_hochrechnung;
                // Zunächst Umrechnung prüfen
                const key_co2_fuss_menge_einheit = 'co2_fussabdruck_' + energietraeger_id + '_' + einheit_id + '_menge';
                const key_co2_fuss_value_einheit = 'co2_fussabdruck_' + energietraeger_id + '_' + einheit_id + '_value';
                const kwh_faktor_id = energietraeger_obj.kwh_faktor;
                let kwh_faktor_quelle: string = null;
                const kwh_faktor = getUmrechungsFaktor(data, '', jahr, kwh_faktor_id,
                    (data: any) => kwh_faktor_quelle = data[`quelle_${kwh_faktor_id}`]);
                let verbrauch_use = item.verbrauch;
                if (umrechnung) {
                    verbrauch_use = verbrauch_use * umrechnung.factor;
                }
                verbrauch_hoch = typeof item.verbrauch === 'number'
                    ? item.verbrauch * factor_hochrechnung : null;
                verbrauch_kwh = typeof item.verbrauch === 'number'
                    ? verbrauch_use * (kwh_faktor ? kwh_faktor : 1) * factor_hochrechnung : null;
                const verbrauch_prozess_kwh = verbrauch_kwh * prozess_fakt;
                let co2_faktor = getEmissionsFaktor(data, '', jahr, energietraeger_obj.co2_faktor);
                let co2_faktor_quelle = 'Emissionsfaktor lt. Versorgerrechnung / Eingabe durch Nutzer';
                if ((energietraeger_id === 'fernwaerme' || energietraeger_id === 'fernkaelte' || energietraeger_id === 'andere' || energietraeger_id === 'strom') &&
                    (item.co2_emissionen || item.co2_emissionen === 0)) {
                    co2_faktor = item.co2_emissionen / (einheit_id === 'mwh' ? 1000000000 : 1000000);
                } else if (energietraeger_id === 'strom' && (base[jahr].faktor_strom_co2 || base[jahr].faktor_strom_co2 === 0)) {
                    co2_faktor = base[jahr].faktor_strom_co2;
                } else {
                    co2_faktor_quelle = (getEmissionsFaktorObject(data, '', jahr, energietraeger_obj.co2_faktor) || {}).quelle || null;
                }
                // WKETOOL-300: Kein Heizwert/Brennwert-Faktor bei der Berechnung von Emissionen, die nicht in kWh angegeben sind.
                // const bum_faktor = getBrennwerteUmrechnungsfaktor(energietraeger_id);
                const bum_faktor: any = null;
                const co2_emission = typeof item.verbrauch === 'number'
                    ? (co2_faktor * verbrauch_kwh) : null;
                const co2_bundesdurchschnitt = typeof item.verbrauch === 'number' ? verbrauch_kwh * (getCO2Aequivalent(data, jahr, 'strom', false) || {}).wert : null;
                base[jahr][key_verbrauch_kwh] = (base[jahr][key_verbrauch_kwh] || 0) + verbrauch_kwh;
                base[jahr][key_weitergeleitete_waermemenge_kwh] = (base[jahr][key_weitergeleitete_waermemenge_kwh] || 0) + (item.weitergeleitete_waermemenge_kwh || 0);
                base[jahr][key_verbrauch_prozess_kwh] = (base[jahr][key_verbrauch_prozess_kwh] || 0) + verbrauch_prozess_kwh;
                base[jahr][key_emission_co2] = (base[jahr][key_emission_co2] || 0) + co2_emission;
                base[jahr][key_co2_fuss_value] = (base[jahr][key_co2_fuss_value] || 0) + co2_emission;
                base[jahr][key_co2_fuss_menge_einheit] = (base[jahr][key_co2_fuss_menge_einheit] || 0) + item.verbrauch * factor_hochrechnung;
                base[jahr][key_co2_fuss_value_einheit] = (base[jahr][key_co2_fuss_value_einheit] || 0) + co2_emission;
                base[jahr][key_co2_quelle + '_2'] = co2_faktor_quelle;
                data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_quelle] = co2_faktor_quelle;
                data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_menge_einheit] = (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_menge_einheit] || 0) + item.verbrauch * factor_hochrechnung;
                data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value_einheit] = (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value_einheit] || 0) + co2_emission;

                // Für DatenauswertungEnergietraegerNeu
                let kenn_item_menge: Kennzahl;
                {
                    // ************ KENN MENGE ******************
                    const kenn_menge: Kennzahl = getKennzahl(energietraeger_id, 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_menge.isInitialized()) {
                        kenn_menge
                            .setEinheit('kWh')
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`Verbrauch Wärme ${energietraeger_name}`)
                            .setGesamt('waerme_gesamt')
                            .setGesamtName('Verbrauch Wärme Gesamt');
                    }
                    kenn_item_menge = kenn_menge.addValue(verbrauch_kwh, item.tid);
                    kenn_item_menge
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setEinheitOrig(einheit_id)
                        .setValueOrig(item.verbrauch)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    if (umrechnung) {
                        kenn_item_menge
                            .addFaktor(umrechnung.factor, KennzahlFaktor.TYPE_UMRECHNUNG, '', `Umrechnung Einheit (${einheit_obj.name || ''} zu ${umrechnung.name || ''})`)
                            .setFormel('verbrauch_umrechnung');
                    }
                    if (kwh_faktor) {
                        kenn_item_menge
                            .addFaktor(kwh_faktor, KennzahlFaktor.TYPE_UMRECHNUNG, kwh_faktor_quelle, 'Umrechnung kWh')
                            .setFormel('verbrauch_umrechnung');
                    }
                    if (factor_hochrechnung !== 1) {
                        kenn_item_menge
                            .addFaktor(
                                factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                            )
                            .setFormel('verbrauch_hochrechnung');
                    }
                    // ************ KENN CO2-EMISSION ******************
                    const kenn_co2: Kennzahl = getKennzahl(energietraeger_id, 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_co2.isInitialized()) {
                        kenn_co2
                            .setEinheit('tCO₂Äq')
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`CO₂-Emission Wärme ${energietraeger_name}`)
                            .setGesamt('waerme_gesamt')
                            .setGesamtName('CO₂-Emission Wärme Gesamt');
                    }
                    const kenn_item_co2: Kennzahl = kenn_co2.addValue(co2_emission, item.tid);
                    kenn_item_co2
                        .setType(Kennzahl.TYPE_EINGABE)
                        .addItem(kenn_item_menge)
                        .setValueOrig(verbrauch_kwh)
                        .setEinheitOrig(einheit_id)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setFormel('co2_emission')
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    // Umrechnungsfaktor Heizwert/Brennwert
                    if (bum_faktor) {
                        kenn_item_co2
                            .addFaktor(bum_faktor.wert, KennzahlFaktor.TYPE_UMRECHNUNG, bum_faktor.quelle, 'Umrechnungsfaktor Heizwert/Brennwert')
                            .setFormel('umrechnung_co2');
                    }
                    // CO2 Faktor
                    kenn_item_co2
                        .addFaktor(co2_faktor, KennzahlFaktor.TYPE_CO2, co2_faktor_quelle, 'CO₂-Faktor');

                    // setRenewable
                    if (isRenewableWaerme(energietraeger_id, co2_faktor)) {
                        base[jahr].verbrauch_waerme_renewable = (base[jahr].verbrauch_waerme_renewable || 0) + (verbrauch_kwh || 0);
                        base[jahr].co2_waerme_renewable = (base[jahr].co2_waerme_renewable || 0) + (co2_emission || 0);
                        setKennzahlRenewableWaerme(item, data, verbrauch_kwh, co2_emission, kenn_menge, kenn_co2);
                    }
                }

                // Für DatenauswertungCO2FussabdruckDetails
                {
                    // ************ KENN MENGE ******************
                    const kennKey = `waerme_${energietraeger_id}_${einheit_id}`;
                    const kenn_menge_ee: Kennzahl = getKennzahl(kennKey, 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    const kenn_bundesdurchschnitt: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_menge_ee.isInitialized()) {
                        kenn_menge_ee
                            .setEinheit(einheit_id)
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`Verbrauch Wärme ${energietraeger_name} ${einheit_id}`);
                    }
                    const kenn_item_menge_ee: Kennzahl = kenn_menge_ee.addValue(verbrauch_hoch, item.tid);
                    let kenn_item_bundesdurchschnitt: Kennzahl;
                    kenn_item_menge_ee
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setEinheitOrig(einheit_id)
                        .setValueOrig(item.verbrauch)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    if (factor_hochrechnung !== 1) {
                        kenn_item_menge_ee
                            .addFaktor(
                                factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                            )
                            .setFormel('hochrechnung');
                    }
                    if (energietraeger_id === 'strom') {
                        if (!kenn_bundesdurchschnitt.isInitialized()) {
                            kenn_bundesdurchschnitt
                                .setEinheit('kWh')
                                .setBereich(Kennzahl.BEREICH_SCOPE2)
                                .setType(Kennzahl.TYPE_SUMME)
                                .setName('Verbrauch Strom Bundesdurchschnitt');
                        }
                        kenn_item_bundesdurchschnitt = kenn_bundesdurchschnitt.addValue(verbrauch_hoch, item.tid);
                        kenn_item_bundesdurchschnitt
                            .setType(Kennzahl.TYPE_EINGABE)
                            .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                            .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                        if (factor_hochrechnung !== 1) {
                            kenn_item_bundesdurchschnitt
                                .setType(Kennzahl.TYPE_EINGABE)
                                .setEinheitOrig('kWh')
                                .setValueOrig(item.verbrauch)
                                .addFaktor(
                                    factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                    `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                    { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                                )
                                .setFormel('hochrechnung');
                        }
                    }
                    // ************ KENN CO2-EMISSION ******************
                    const kenn_co2_ee: Kennzahl = getKennzahl(kennKey, 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    const kenn_bundesdurchschnitt_co2: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_co2_ee.isInitialized()) {
                        kenn_co2_ee
                            .setEinheit('tCO₂Äq')
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`CO₂-Emission Wärme ${energietraeger_name} ${einheit_id}`);
                    }
                    const kenn_item_co2_ee: Kennzahl = kenn_co2_ee.addValue(co2_emission, item.tid);
                    kenn_item_co2_ee
                        .setType(Kennzahl.TYPE_EINGABE)
                        .addItem(kenn_item_menge)
                        .setValueOrig(verbrauch_kwh)
                        .setEinheitOrig('kWh')
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setFormel('co2_emission')
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    // Umrechnungsfaktor Heizwert/Brennwert
                    if (bum_faktor) {
                        kenn_item_co2_ee
                            .addFaktor(bum_faktor.wert, KennzahlFaktor.TYPE_UMRECHNUNG, bum_faktor.quelle, 'Umrechnungsfaktor Heizwert/Brennwert')
                            .setFormel('umrechnung_co2');
                    }
                    // CO2 Faktor
                    kenn_item_co2_ee
                        .addFaktor(co2_faktor, KennzahlFaktor.TYPE_CO2, co2_faktor_quelle, 'CO₂-Faktor');

                    if (energietraeger_id === 'strom') {
                        const co2_faktor_strom: any = getCO2Aequivalent(data, jahr, 'strom', false) || {};
                        if (!kenn_bundesdurchschnitt_co2.isInitialized()) {
                            kenn_bundesdurchschnitt_co2
                                .setEinheit('tCO₂Äq')
                                .setBereich(Kennzahl.BEREICH_SCOPE2)
                                .setType(Kennzahl.TYPE_SUMME)
                                .setName('CO₂-Emission Strom Bundesdurchschnitt');
                        }
                        const kenn_item_bundesdurchschnitt_co2: Kennzahl = kenn_bundesdurchschnitt_co2.addValue(co2_bundesdurchschnitt, item.tid);
                        kenn_item_bundesdurchschnitt_co2
                            .setType(Kennzahl.TYPE_BERECHNUNG)
                            .addItem(kenn_item_bundesdurchschnitt)
                            .addFaktor(co2_faktor_strom.wert, KennzahlFaktor.TYPE_CO2, co2_faktor_strom.quelle, 'CO₂-Faktor')
                            .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    }
                }
            } else {
                // einheit_id === 'kwh'
                const verbrauch_prozess_kwh = item.verbrauch * factor_hochrechnung * prozess_fakt;
                let co2_faktor = getEmissionsFaktor(data, '', jahr, energietraeger_obj.co2_faktor);
                let co2_faktor_quelle = 'Emissionsfaktor lt. Versorgerrechnung / Eingabe durch Nutzer';
                if ((energietraeger_id === 'fernwaerme' || energietraeger_id === 'fernkaelte' || energietraeger_id === 'andere' || energietraeger_id === 'strom') &&
                    (item.co2_emissionen || item.co2_emissionen === 0)) {
                    co2_faktor = item.co2_emissionen / 1000000;
                    co2_faktor_quelle = 'Emissionsfaktor lt. Versorgerrechnung / Eingabe durch Nutzer';
                } else if (energietraeger_id === 'strom' && (base[jahr].faktor_strom_co2 || base[jahr].faktor_strom_co2 === 0)) {
                    co2_faktor = base[jahr].faktor_strom_co2;
                } else {
                    co2_faktor_quelle = (getEmissionsFaktorObject(data, '', jahr, energietraeger_obj.co2_faktor) || {}).quelle || null;
                }

                verbrauch_kwh = +item.verbrauch * factor_hochrechnung;
                // einheit_id === 'kwh' -> Umrechnungsfaktor Heizwert/Brennwert
                const bum_faktor = getBrennwerteUmrechnungsfaktor(energietraeger_id);
                const co2_emission = typeof item.verbrauch === 'number' ?
                    co2_faktor * item.verbrauch * factor_hochrechnung * (bum_faktor ? bum_faktor.wert : 1)
                    : null;
                const co2_bundesdurchschnitt = typeof item.verbrauch === 'number' ? verbrauch_kwh * (getCO2Aequivalent(data, jahr, 'strom', false) || {}).wert : null;
                base[jahr][key_verbrauch_kwh] = (base[jahr][key_verbrauch_kwh] || 0) + verbrauch_kwh;
                base[jahr][key_weitergeleitete_waermemenge_kwh] = (base[jahr][key_weitergeleitete_waermemenge_kwh] || 0) + (item.weitergeleitete_waermemenge_kwh || 0);
                base[jahr][key_verbrauch_kwh_base] = (base[jahr][key_verbrauch_kwh_base] || 0) + verbrauch_kwh * (bum_faktor ? bum_faktor.wert : 1);
                base[jahr][key_verbrauch_prozess_kwh] = (base[jahr][key_verbrauch_prozess_kwh] || 0) + verbrauch_prozess_kwh;
                base[jahr][key_emission_co2] = (base[jahr][key_emission_co2] || 0) + co2_emission;
                base[jahr][key_co2_fuss_value] = (base[jahr][key_co2_fuss_value] || 0) + co2_emission;
                base[jahr][key_co2_fuss_menge] = (base[jahr][key_co2_fuss_menge] || 0) + verbrauch_kwh;
                base[jahr][key_co2_quelle] = co2_faktor_quelle;
                base[jahr][key_co2_wert] = co2_faktor;

                if (energietraeger_id === 'strom') {
                    const strom_bundesdurchschnitt = typeof item.verbrauch === 'number' ? verbrauch_kwh : null;
                    base[jahr].strom_bundesdurchschnitt = strom_bundesdurchschnitt + (base[jahr].strom_bundesdurchschnitt || 0);
                    base[jahr].co2_strom_bundesdurchschnitt = co2_bundesdurchschnitt + (base[jahr].co2_strom_bundesdurchschnitt || 0);
                    data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt = strom_bundesdurchschnitt + (data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt || 0);
                    data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt = co2_bundesdurchschnitt + (data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt || 0);

                }
                data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_quelle] = co2_faktor_quelle;
                data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_menge] = (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_menge] || 0) + verbrauch_kwh;

                // WKETOOL-300: CL 653
                // Kommentiere die folgende Zeile aus, weil sie dazu führt, dass sich der Emissionsfaktor für Fernwärme verdoppelt.
                // data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value] = (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value] || 0) + co2_emission;

                // Für DatenauswertungEnergietraegerNeu
                {
                    // ************ KENN MENGE ******************
                    const kenn_menge: Kennzahl = getKennzahl(energietraeger_id, 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_menge.isInitialized()) { // Da Summe, müssen wir mit dem ersten Wert ein paar Dinge initialisieren
                        kenn_menge
                            .setEinheit(einheit_id)
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`Verbrauch Wärme ${energietraeger_name}`)
                            .setGesamt('waerme_gesamt')
                            .setGesamtName('Verbrauch Wärme Gesamt');
                    }
                    const kenn_item_menge: Kennzahl = kenn_menge.addValue(verbrauch_kwh, item.tid);
                    kenn_item_menge
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    if (factor_hochrechnung !== 1) {
                        kenn_item_menge
                            .setType(Kennzahl.TYPE_EINGABE)
                            .setEinheitOrig('kWh')
                            .setValueOrig(item.verbrauch)
                            .addFaktor(
                                factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                            )
                            .setFormel('verbrauch_hochrechnung');
                    }
                    // ************ KENN CO2-EMISSION ******************
                    const kenn_co2: Kennzahl = getKennzahl(energietraeger_id, 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_co2.isInitialized()) {
                        kenn_co2
                            .setEinheit('tCO₂Äq')
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`CO₂-Emission Wärme ${energietraeger_name}`)
                            .setGesamt('waerme_gesamt')
                            .setGesamtName('CO₂-Emission Wärme Gesamt');
                    }
                    const kenn_item_co2: Kennzahl = kenn_co2.addValue(co2_emission, item.tid);
                    kenn_item_co2
                        .addItem(kenn_item_menge)
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setValueOrig(verbrauch_kwh)
                        .setEinheitOrig(einheit_id)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis)
                        .setFormel('co2_emission');
                    // Umrechnungsfaktor Heizwert/Brennwert
                    if (bum_faktor) {
                        kenn_item_co2
                            .addFaktor(bum_faktor.wert, KennzahlFaktor.TYPE_UMRECHNUNG, bum_faktor.quelle, 'Umrechnungsfaktor Heizwert/Brennwert')
                            .setFormel('umrechnung_co2');
                    }
                    // CO2 Faktor
                    kenn_item_co2
                        .addFaktor(co2_faktor, KennzahlFaktor.TYPE_CO2, co2_faktor_quelle, 'CO₂-Faktor');

                    // setRenewable
                    if (isRenewableWaerme(energietraeger_id, co2_faktor)) {
                        base[jahr].verbrauch_waerme_renewable = (base[jahr].verbrauch_waerme_renewable || 0) + (verbrauch_kwh || 0);
                        base[jahr].co2_waerme_renewable = (base[jahr].co2_waerme_renewable || 0) + (co2_emission || 0);
                        setKennzahlRenewableWaerme(item, data, verbrauch_kwh, co2_emission, kenn_menge, kenn_co2);
                    }
                }

                // Für DatenauswertungCO2FussabdruckDetails
                {
                    // ************ KENN MENGE ******************
                    const kennKey = `waerme_${energietraeger_id}_kwh`;
                    const kenn_menge_ee: Kennzahl = getKennzahl(kennKey, 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    const kenn_bundesdurchschnitt: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_menge_ee.isInitialized()) { // Da Summe, müssen wir mit dem ersten Wert ein paar Dinge initialisieren
                        kenn_menge_ee
                            .setEinheit(einheit_id)
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`Verbrauch Wärme ${energietraeger_name} kWh`);
                    }
                    const kenn_item_menge_ee: Kennzahl = kenn_menge_ee.addValue(verbrauch_kwh, item.tid);
                    let kenn_item_bundesdurchschnitt: Kennzahl;
                    kenn_item_menge_ee
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    if (factor_hochrechnung !== 1) {
                        kenn_item_menge_ee
                            .setType(Kennzahl.TYPE_EINGABE)
                            .setEinheitOrig('kWh')
                            .setValueOrig(item.verbrauch)
                            .addFaktor(
                                factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                            )
                            .setFormel('hochrechnung');
                    }
                    if (energietraeger_id === 'strom') {
                        if (!kenn_bundesdurchschnitt.isInitialized()) {
                            kenn_bundesdurchschnitt
                                .setEinheit('kWh')
                                .setBereich(Kennzahl.BEREICH_SCOPE2)
                                .setType(Kennzahl.TYPE_SUMME)
                                .setName('Verbrauch Strom Bundesdurchschnitt');
                        }
                        kenn_item_bundesdurchschnitt = kenn_bundesdurchschnitt.addValue(verbrauch_kwh, item.tid);
                        kenn_item_bundesdurchschnitt
                            .setType(Kennzahl.TYPE_EINGABE)
                            .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                            .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                        if (factor_hochrechnung !== 1) {
                            kenn_item_bundesdurchschnitt
                                .setType(Kennzahl.TYPE_EINGABE)
                                .setEinheitOrig('kWh')
                                .setValueOrig(item.verbrauch)
                                .addFaktor(
                                    factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                                    `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                                    { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                                )
                                .setFormel('hochrechnung');
                        }
                    }
                    // ************ KENN CO2-EMISSION ******************
                    const kenn_co2_ee: Kennzahl = getKennzahl(kennKey, 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    const kenn_bundesdurchschnitt_co2: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_co2_ee.isInitialized()) {
                        kenn_co2_ee
                            .setEinheit('tCO₂Äq')
                            .setBereich(Kennzahl.BEREICH_WAERME)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName(`CO₂-Emission Wärme ${energietraeger_name} kWh`);
                    }
                    const kenn_item_co2_ee: Kennzahl = kenn_co2_ee.addValue(co2_emission, item.tid);
                    kenn_item_co2_ee
                        .addItem(kenn_item_menge_ee)
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setValueOrig(item.verbrauch * factor_hochrechnung)
                        .setEinheitOrig(einheit_id)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis)
                        .setFormel('co2_emission');
                    // Umrechnungsfaktor Heizwert/Brennwert
                    if (bum_faktor) {
                        kenn_item_co2_ee
                            .addFaktor(bum_faktor.wert, KennzahlFaktor.TYPE_UMRECHNUNG, bum_faktor.quelle, 'Umrechnungsfaktor Heizwert/Brennwert')
                            .setFormel('umrechnung_co2');
                    }
                    // CO2 Faktor
                    kenn_item_co2_ee
                        .addFaktor(co2_faktor, KennzahlFaktor.TYPE_CO2, co2_faktor_quelle, 'CO₂-Faktor');
                    if (energietraeger_id === 'strom') {
                        const co2_faktor_strom: any = getCO2Aequivalent(data, jahr, 'strom', false) || {};
                        if (!kenn_bundesdurchschnitt_co2.isInitialized()) {
                            kenn_bundesdurchschnitt_co2
                                .setEinheit('tCO₂Äq')
                                .setBereich(Kennzahl.BEREICH_SCOPE2)
                                .setType(Kennzahl.TYPE_SUMME)
                                .setName('CO₂-Emission Strom Bundesdurchschnitt');
                        }
                        const kenn_item_bundesdurchschnitt_co2: Kennzahl = kenn_bundesdurchschnitt_co2.addValue(co2_bundesdurchschnitt, item.tid);
                        kenn_item_bundesdurchschnitt_co2
                            .setType(Kennzahl.TYPE_BERECHNUNG)
                            .addItem(kenn_item_bundesdurchschnitt)
                            .addFaktor(co2_faktor_strom.wert, KennzahlFaktor.TYPE_CO2, co2_faktor_strom.quelle, 'CO₂-Faktor')
                            .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    }
                }
            }

            // ************ KENN KOSTEN ******************
            const kenn_kosten: Kennzahl = getKennzahl(energietraeger_id, 'kosten', jahr, standortTid ? standortTid : 'ALL', data);
            if (!kenn_kosten.isInitialized()) {
                kenn_kosten
                    .setEinheit('€')
                    .setBereich(Kennzahl.BEREICH_WAERME)
                    .setType(Kennzahl.TYPE_SUMME)
                    .setName(`Kosten Wärme ${energietraeger_name}`)
                    .setGesamt('waerme_gesamt')
                    .setGesamtName('Kosten Wärme Gesamt');
            }
            const kenn_item_kosten: Kennzahl = kenn_kosten.addValue(kosten, item.tid);
            kenn_item_kosten
                .setType(Kennzahl.TYPE_EINGABE)
                .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
            if (factor_hochrechnung !== 1) {
                kenn_item_kosten
                    .setType(Kennzahl.TYPE_EINGABE)
                    .setEinheitOrig('€')
                    .setValueOrig(item.kosten)
                    .addFaktor(
                        factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, factor_hochrechnung_quelle,
                        `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                        { gtz: { value: gtz_hochrechnung, valueOrig: gtz_az }, tage: { value: tage_hochrechnung, valueOrig: tage_az } }
                    );
            }
        }

        base[jahr][key_datenqualitaet].push({
            wert: +(item.verbrauch || 0) * factor_hochrechnung, datenherkunft: +(item.datenherkunft || 0), bewertung: 1
        });
        base[jahr].az_von_waerme = (!base[jahr].az_von_waerme || base[jahr].az_von_waerme > item.abrechnungszeitraum_von) ?
            item.abrechnungszeitraum_von : base[jahr].az_von_waerme;
        base[jahr].az_bis_waerme = (!base[jahr].az_bis_waerme || base[jahr].az_bis_waerme < item.abrechnungszeitraum_bis) ?
            item.abrechnungszeitraum_bis : base[jahr].az_bis_waerme;
    });

    /******************** GTZ HOCHRECHNUNG ****************************************************************** */
    // Hier der Durchlauf für die GTZ-Berechnung
    if (standort) {
        Object.keys(base).forEach((jahr: any) => {
            Object.keys(energietraeger_found).forEach((energietraeger_id: string) => {
                if (+jahr > 0) {
                    const az_von = base[jahr].az_von_waerme;
                    const az_bis = base[jahr].az_bis_waerme;
                    if (az_von && az_bis) {
                        const key_kosten = 'kosten_waerme_' + energietraeger_id;
                        const key_verbrauch_kwh = 'verbrauch_waerme_' + energietraeger_id + '_kwh';
                        const key_weitergeleitete_waermemenge_kwh = 'weitergeleitete_waermemenge_' + energietraeger_id + '_kwh';
                        const key_verbrauch_kwh_base = 'verbrauch_waerme_' + energietraeger_id + '_kwh_base';
                        const key_verbrauch_prozess_kwh = 'verbrauch_waerme_prozess_' + energietraeger_id + '_kwh';
                        const key_emission_co2 = 'co2_waerme_' + energietraeger_id;
                        const key_co2_fuss_value = energietraeger_id === 'strom' ? 'co2_fussabdruck_strom_waerme_value' :
                            'co2_fussabdruck_' + energietraeger_id + '_value';
                        const kosten_in = base[jahr][key_kosten];
                        const verbrauch_in = base[jahr][key_verbrauch_kwh];
                        const verbrauch_prozess_in = base[jahr][key_verbrauch_prozess_kwh];
                        if (verbrauch_in || kosten_in) {
                            const co2_in = base[jahr][key_emission_co2];
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_kosten] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_kosten] || 0) + kosten_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_kwh] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_kwh] || 0) + verbrauch_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_weitergeleitete_waermemenge_kwh] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_weitergeleitete_waermemenge_kwh] || 0) + base[jahr][key_weitergeleitete_waermemenge_kwh];
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_kwh_base] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_kwh_base] || 0) + verbrauch_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_prozess_kwh] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_verbrauch_prozess_kwh] || 0) + verbrauch_prozess_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_emission_co2] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_emission_co2] || 0) + co2_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value] =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr][key_co2_fuss_value] || 0) + co2_in;
                            base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten_in;
                            base[jahr].verbrauch_total = (base[jahr].verbrauch_total || 0) + verbrauch_in;
                            base[jahr].kosten_waerme = (base[jahr].kosten_waerme || 0) + kosten_in;
                            base[jahr].verbrauch_waerme_kwh = (base[jahr].verbrauch_waerme_kwh || 0) + verbrauch_in;
                            base[jahr].co2_waerme = (base[jahr].co2_waerme || 0) + co2_in;
                            // Hier die Gesamtkosten nun setzen
                            data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_total =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_total || 0) + kosten_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_waerme =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_waerme || 0) + kosten_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_total =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_total || 0) + verbrauch_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_waerme_kwh =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_waerme_kwh || 0) + verbrauch_in;
                            data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_waerme =
                                (data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_waerme || 0) + co2_in;
                        }
                    }
                }
            });
        });
    }
}
